

export const DATA_TABLE_ROW_HOVERABLE_TYPE = {
  AVAILABLE: 'available',
  NOT_AVAILABLE: 'not-available'
};